export function getSecondaryCount(tx) {
  return tx.filter(t => !t.primary_payer).length
}
